export const MixpanelProjectToken = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN || "";
export const env = process.env.REACT_APP_ENV;
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const orderingUrl = process.env.REACT_APP_ORDERING_URL;
export const verbiText = process.env.REACT_APP_VERBITEXT_URL;
export const loginUrl = process.env.REACT_APP_LOGIN_URL;
export const appUrl = process.env.REACT_APP_APP_URL;
export const kwartzUrl = process.env.REACT_APP_KWARTZ_URL;
export const rollbarAccessToken = process.env.REACT_APP_ROLLBAR_TOKEN;
export const supportLink = process.env.REACT_APP_SUPPORT;
export const appName = process.env.REACT_APP_NAME;
